import React, { useRef, useEffect, useState } from "react";

const DynamicTabSelector = ({
  tabs = [],
  selectedTabIndex = 0, // Use external state for selected tab index
  onTabSelected = () => {},
  style = {},
}) => {
  const [tabWidth, setTabWidth] = useState(0);
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      setTabWidth(containerRef.current.offsetWidth / tabs.length);
    }
  }, [tabs.length]);

  const handleTabClick = (index) => {
    onTabSelected(index); // Notify the parent component of the selected tab
  };

  return (
    <div ref={containerRef} style={{ ...styles.tabContainer, ...style }}>
      {tabs.map((tab, index) => (
        <div
          key={index}
          style={{
            ...styles.tabItem,
            color:
              selectedTabIndex === index ? "var(--text)" : "var(--text-faint)",
          }}
          onClick={() => handleTabClick(index)}
        >
          {tab}
        </div>
      ))}
      <div
        style={{
          ...styles.tabIndicator,
          width: `${tabWidth}px`,
          transform: `translateX(${
            selectedTabIndex * tabWidth - 1 * selectedTabIndex
          }px)`,
        }}
      />
    </div>
  );
};

const styles = {
  tabContainer: {
    display: "flex",
    justifyContent: "space-evenly",
    position: "fixed", // Change to fixed
    top: "50px",
    left: 0,
    backgroundColor: "var(--surface)",
    borderRadius: "8px",
    height: "40px",
    width: "100%",
    padding: "0",
    zIndex: 999,
  },
  tabItem: {
    flex: 1,
    textAlign: "center",
    padding: "10px 0",
    cursor: "pointer",
    transition: "color 0.3s ease",
    zIndex: 1,
  },
  tabIndicator: {
    position: "absolute",
    bottom: "4px",
    left: "0",
    height: "28px",
    backgroundColor: "var(--bar)",
    border: "2px solid var(--primary)",
    borderRadius: "8px",
    transition: "transform 0.3s ease",
    zIndex: 0,
  },
};

export default DynamicTabSelector;
